module.exports = "<svg id=\"chevron\" viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\">\n\t<path d=\"M6.5 3.5l6 5.5-6 5.5\"/>\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./theroot/root-100-2019/src/img/chevron.svg
// module id = 205
// module chunks = 0